export class SetPasswordRequest {
  Password: string;
  RepeatPassword: string;
  ResetToken: string | null;
}
